<template>
  <div>
    <div>
      <a-form-model ref="form" :model="form.data" :rules="form.rules">
        <a-form-model-item label="商品编码">
          <a-input v-model="form.data.code"/>
        </a-form-model-item>
        <a-form-model-item label="库存数量">
          <a-input-number v-model="form.data.quantity"/>
        </a-form-model-item>
        <a-form-model-item label="价格">
          <a-input-number v-model="form.data.price"/>
        </a-form-model-item>
        <!--        <a-form-model-item label="描述">-->
        <!--          <a-input-number v-model="form.data.description"/>-->
        <!--        </a-form-model-item>-->
        <a-form-model-item label="图集">
          <div class="a-input">
            <multi-uploader
              v-model="form.data.images"
              :options="imagesOptions"/>
          </div>
        </a-form-model-item>
        <a-form-model-item label="">
          <a-space>
            <a-button type="primary" v-if="!goodsSkuId" @click="onAdd">创建</a-button>
            <a-button type="primary" v-if="goodsSkuId" @click="onUpdate">更新</a-button>
            <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { _addGoodsSku, _queryGoodsSku, _updateGoodsSku, } from '@/api/goodsSkuApi';
import MultiUploader from '@/components/MultiUploader.vue';

async function getGoodsSku() {
  const result = await _queryGoodsSku(this.goodsSkuId, {});
  if (result) {
    this.form.data.image = result.image;
    // this.form.data.modelSizeImage = result.modelSizeImage;
    // this.form.data.modelSizeDetail = result.modelSizeDetail;
    this.form.data.code = result.code;
    this.form.data.images = result.images ? result.images.split('|') : [];
    // this.form.data.modelImages = result.modelImages ? result.modelImages.split(',') : [];
    this.form.data.price = result.price;
    this.form.data.description = result.description;
    this.form.data.quantity = result.quantity;
    // this.form.data.storageBin = result.storageBin;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      await _addGoodsSku({
        image: this.form.data.image,
        // modelSizeImage: this.form.data.modelSizeImage,
        // modelSizeDetail: this.form.data.modelSizeDetail,
        code: this.form.data.code,
        // modelImages: this.form.data.modelImages.join(','),
        images: this.form.data.images.join('|'),
        description: this.form.data.description,
        price: this.form.data.price,
        quantity: this.form.data.quantity,
        // storageBin: this.form.data.storageBin,
      });
      this.$message.success('添加成功');
      if (this.onSubmitHandler) {
        this.onSubmitHandler();
      } else {
        await this.$router.push(-1);
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      await _updateGoodsSku(this.goodsSkuId, {
        image: this.form.data.image,
        // modelSizeImage: this.form.data.modelSizeImage,
        // modelSizeDetail: this.form.data.modelSizeDetail,
        code: this.form.data.code,
        // modelImages: this.form.data.modelImages.join(','),
        images: this.form.data.images.join('|'),
        description: this.form.data.description,
        price: this.form.data.price,
        quantity: this.form.data.quantity,
        // storageBin: this.form.data.storageBin,
      });
      this.$message.success('添加成功');
      if (this.onSubmitHandler) {
        this.onSubmitHandler();
      } else {
        await this.$router.push(-1);
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsSkuEdit',
  components: {
    MultiUploader,
    // SimpleUploader,
  },
  props: {
    goodsSkuId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    goodsSkuId() {
      if (this.goodsSkuId) {
        this.getGoodsSku();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getGoodsSku,
  },
  data() {
    return {
      imagesOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 385, // 默认生成截图框宽度
        autoCropHeight: 481, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        multi: true,
        serviceType: 'OSS',
        title: '修改图片',
      },
      form: {
        data: {
          image: '',
          // modelSizeImage: '',
          // modelSizeDetail: '',
          images: [],
          code: '',
          description: '',
          // modelImages: [],
          price: 0,
          quantity: 0,
          // storageBin: '',
        },
        rules: {
          code: [{ required: true, trigger: 'blur' }],
          price: [{ required: true, trigger: 'blur' }],
          quantity: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.goodsSkuId) {
      this.getGoodsSku();
    }
  },
};
</script>
